import { focusRingStyle } from "./styles.mjs";
import { Text } from "./Text.mjs";
import { ThemeOverride, useTheme } from "./ThemeProvider.mjs";
import { useStyles } from "purse-styles";
import React from "react";
import { Checkbox as Checkbox$1, Label } from "react-aria-components";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";

//#region src/Checkbox.tsx
const Checkbox = ({ label, "aria-label": ariaLabel, size = "md", style: style$1, className: classNameProp, isSelected, defaultSelected, onChange, isIndeterminate, isDisabled, isReadOnly, isRequired, isInvalid, flex, basis, grow, shrink, alignSelf, internal_slot }) => {
	const theme = useTheme();
	const checkboxSize = size === "sm" ? 16 : 20;
	const borderRadius = theme.borderRadiuses.sm;
	const flexStyles = {
		flex: flex === true ? 1 : flex,
		flexBasis: basis,
		flexGrow: grow === true ? 1 : grow,
		flexShrink: shrink === true ? 1 : shrink,
		alignSelf
	};
	const className = useStyles({
		display: "inline-flex",
		alignItems: "center",
		gap: theme.spacing.xs,
		cursor: isDisabled ? "not-allowed" : void 0,
		opacity: isDisabled ? .6 : 1,
		pointerEvents: isDisabled ? "none" : void 0,
		...flexStyles,
		...style$1
	});
	const checkboxClassName = useStyles(focusRingStyle({ theme }), {
		position: "relative",
		width: checkboxSize,
		height: checkboxSize,
		borderRadius,
		border: `1px solid ${theme.colors.sandA5}`,
		background: theme.colors.sand1,
		flexShrink: 0,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		transition: "all 150ms ease",
		"&:hover": isDisabled ? void 0 : {
			borderColor: theme.colors.sandA8,
			background: theme.colors.sand2
		},
		"&[data-focus-visible]": { borderColor: theme.colors.accent8 },
		"&[data-pressed]": isDisabled ? void 0 : { background: theme.colors.sand3 },
		"&[data-selected]": {
			background: theme.colors.accent9,
			borderColor: theme.colors.accent9
		},
		"&[data-selected]:hover": isDisabled ? void 0 : {
			background: theme.colors.accent10,
			borderColor: theme.colors.accent10
		},
		"&[data-indeterminate]": {
			background: theme.colors.accent9,
			borderColor: theme.colors.accent9
		},
		"&[data-indeterminate]:hover": isDisabled ? void 0 : {
			background: theme.colors.accent10,
			borderColor: theme.colors.accent10
		},
		"&[data-invalid]": { borderColor: theme.colors.red8 },
		"&[data-invalid]:hover": isDisabled ? void 0 : { borderColor: theme.colors.red9 }
	});
	const iconSize = size === "sm" ? 12 : 14;
	return /* @__PURE__ */ jsx(Checkbox$1, {
		slot: internal_slot,
		className: [className, classNameProp].filter(Boolean).join(" "),
		isSelected,
		defaultSelected,
		onChange,
		isIndeterminate,
		isDisabled,
		isReadOnly,
		isRequired,
		isInvalid,
		"aria-label": ariaLabel,
		children: ({ isSelected: isSelected$1, isIndeterminate: isIndeterminate$1 }) => /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("div", {
			className: checkboxClassName,
			children: /* @__PURE__ */ jsx(ThemeOverride, {
				mode: isSelected$1 || isIndeterminate$1 ? "dark" : theme.name,
				children: isIndeterminate$1 ? /* @__PURE__ */ jsx("svg", {
					width: iconSize,
					height: iconSize,
					viewBox: "0 0 16 16",
					fill: "none",
					"aria-hidden": "true",
					children: /* @__PURE__ */ jsx("rect", {
						x: "3",
						y: "7.5",
						width: "10",
						height: "1",
						fill: "currentColor"
					})
				}) : isSelected$1 ? /* @__PURE__ */ jsx("svg", {
					width: iconSize,
					height: iconSize,
					viewBox: "0 0 16 16",
					fill: "none",
					"aria-hidden": "true",
					children: /* @__PURE__ */ jsx("path", {
						d: "M3 8L6.5 11.5L13 4.5",
						stroke: "currentColor",
						strokeWidth: "1.5",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})
				}) : null
			})
		}), label && /* @__PURE__ */ jsx(Label, { children: /* @__PURE__ */ jsx(Text, {
			size,
			weight: "normal",
			children: label
		}) })] })
	});
};

//#endregion
export { Checkbox };